import client from '../../../utils/api'
import { createApiAction } from '../../../utils/redux-tool'

export const search = createApiAction('academic/parent/attendance/search', client.search('/api/attendance/attendance-report'))
export default function setStudentAttendanceReducer(builder) {
  builder.addCase(search.fulfilled, (state, action) => {
    const list = state.list || []
    const { schoolEnrollmentId } = action.meta.arg
    const found = list.find(item => item.employments[0].schoolEnrollments[0].id === schoolEnrollmentId)
    if (found)
      state.list = list.map(item =>
        item.employments[0].schoolEnrollments[0].id === found.employments[0].schoolEnrollments[0].id
          ? { ...item, attendanceReport: action.payload }
          : item,
      )
  })
}
